import { Button, ButtonProps } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

import styles from './TableActionButton.module.scss';

interface TableActionButtonProps extends Pick<ButtonProps, 'className' | 'href' | 'disabled' | 'color'> {
  actionLabel: string;
  nameLabel?: string;
  target?: string;
  onClick?: () => void;
}

const TableActionButton: React.FunctionComponent<TableActionButtonProps> = ({
  actionLabel,
  nameLabel = '',
  href,
  target,
  className = '',
  disabled,
  color = 'primary',
  onClick,
}) => {
  const actionButtonProps: ButtonProps = {
    variant: 'outlined',
    size: 'small',
    color: color,
    className: classNames(styles.actionButton, className),
  };

  return (
    <Button {...actionButtonProps} {...{ href, target, disabled }} onClick={onClick}>
      {`${actionLabel} `}
      {nameLabel && <span className={styles.nameLabel}>{nameLabel}</span>}
    </Button>
  );
};
export default TableActionButton;
